import { Order } from 'storeTypes'

/** UTC day key -- matches the recap's created_since (start of UTC day). */
export const getDailyKey = (now: Date = new Date()): string =>
    now.toISOString().slice(0, 10)

const isDailyEnrollmentDate = (
    enrollmentDate: string | null | undefined,
    dailyKey: string
): boolean => !!enrollmentDate && String(enrollmentDate).slice(0, 10) === dailyKey

/** The service worker's "get all client orders" response is Order[][]
 * (one array per cached client) -- flatten it to a single Order[]. */
export const flattenClientOrdersPayload = (payload: unknown): Order[] => {
    if (!Array.isArray(payload)) return []
    return payload.flat() as Order[]
}

/** Distinct client codes with a confirmed (not dropped) package enrolled
 * today in this village -- the reliable "did they actually enroll"
 * signal, unlike an ENROLLED interaction outcome which can be recorded
 * without any package ever being created. */
export const getDailyEnrolledClientCodes = (
    orders: Order[],
    villageId: string,
    dailyKey: string = getDailyKey()
): Set<string> => {
    const clientCodes = new Set<string>()
    orders.forEach((order) => {
        if (order.dropped) return
        if (order.village_id !== villageId) return
        if (!isDailyEnrollmentDate(order.enrollment_date, dailyKey)) return
        if (order.client_code) clientCodes.add(order.client_code)
    })
    return clientCodes
}
